import Home from './views/Home'
import Accommodation from './views/Accommodation'
import AccommodationSearch from './views/AccommodationSearch'
import Skipass from './views/Skipass'
import Skischool from './views/Skischool'
import Skirental from './views/Skirental'
import Activities from './views/Activities'
import LandingPage from './views/LandingPage'
import Login_view from './views/profile/Login_view'
import ResetPassword_view from './views/profile/ResetPassword_view'
import Create_view from './views/profile/Create_view'
import Profile_view from './views/profile/Profile_view'
import Overview_view from './views/profile/Overview_view'
import ProfileBookings_view from './views/profile/ProfileBookings_view'
import ProfileEdit_view from './views/profile/ProfileEdit_view'
import Guest_view from './views/profile/Guest_view'
// import GuestEdit_view from './views/profile/GuestEdit_view'
import Cart from './views/Cart'
import Payment from './views/Payment'
import Confirmation from './views/Confirmation'
import store from './vueX/store'
import { i18n } from './main'
import { tokenHasExpired } from './session-manager'
import { routes as enRoutes, meta as enMeta } from './lang/translations/en.json'
import { routes as svRoutes, meta as svMeta } from './lang/translations/sv.json'

const getlangFromUrl = window.location.href.includes('/en/')
let lang = document.documentElement.lang

let urlLang = ''

// Set language prefix for routes
if (getlangFromUrl) {
	urlLang = '/en'
	if (window.location.href.includes('localhost')) {
		// Show en in loacal envirement
		lang = 'en'
	}
}

// Set language routes (en as default)
let langRoutes = enRoutes
let langMeta = enMeta
if (lang == 'sv') {
	langRoutes = svRoutes
	langMeta = svMeta
}

const routes = [
	{
		path: `${urlLang}/${langRoutes.book}`,
		component: Home,
		beforeEnter(to, from, next) {
			if (i18n.locale !== lang) {
				i18n.locale = lang
			}
			next()
		},
		children: [
			// Accommodation Search (Root)
			{
				path: ``,
				redirect: { name: 'search' }
			},
			{
				path: `${langRoutes.accommodation}`,
				name: 'search',
				component: AccommodationSearch,
				meta: langMeta.search
			},
			// Accommodation
			{
				path: `${langRoutes.accommodation}/:id`,
				name: 'accommodation',
				component: Accommodation,
				meta: langMeta.accommodation
			},
			// Cart
			{
				path: langRoutes.cart,
				name: 'cart',
				component: Cart,
				meta: langMeta.cart
			},
			// addtocart
			{
				path: langRoutes.addedToCart,
				name: 'addtocart',
				component: LandingPage,
				meta: langMeta.addedToCart
			},
			// Confirmation
			{
				path: langRoutes.confirmation,
				name: 'confirmation',
				component: Confirmation,
				meta: langMeta.confirmation
			},
			// Skipass
			{
				path: langRoutes.skipass,
				name: 'skipass',
				component: Skipass,
				meta: langMeta.skipass
			},
			// Skischool
			{
				path: langRoutes.skiSchool,
				name: 'skischool',
				component: Skischool,
				meta: langMeta.skischool
			},
			// Skirental
			{
				path: langRoutes.equipment,
				name: 'skirental',
				component: Skirental,
				meta: langMeta.skirental
			},
			// Activities
			{
				path: langRoutes.activities,
				name: 'activities',
				component: Activities,
				meta: langMeta.activities
			},
			// Reset password
			{
				path: langRoutes.resetPassword,
				name: 'resetpassword',
				component: ResetPassword_view,
				meta: langMeta.resetPassword,
				beforeEnter(to, from, next) {
					if (store.state.user) {
						next({ name: 'profile' })
					} else {
						next()
					}
				}
			},
			// Login
			{
				path: langRoutes.login,
				name: 'login',
				component: Login_view,
				meta: langMeta.login,
				beforeEnter(to, from, next) {
					if (store.state.user) {
						next({ name: 'profile' })
					} else {
						next()
					}
				}
			},
			// Create profile
			{
				path: langRoutes.createProfile,
				name: 'newaccount',
				component: Create_view,
				meta: langMeta.createProfile,
				beforeEnter(to, from, next) {
					if (store.state.user) {
						next({ name: 'profile' })
					} else {
						next()
					}
				}
			},
			// Payment
			{
				path: langRoutes.payment,
				name: 'payment',
				component: Payment,
				meta: langMeta.payment,
				beforeEnter(to, from, next) {
					if (tokenHasExpired()) {
						store.dispatch('POST_REFRESH_TOKEN').then(success => {
							if (!success) {
								next({ name: 'login' })
							}
						})
					}
					next()
				}
			},
			// Profile
			{
				path: `${langRoutes.profile}`,
				component: Profile_view,
				beforeEnter(to, from, next) {
					if (tokenHasExpired()) {
						store.dispatch('POST_REFRESH_TOKEN').then(success => {
							if (!success) {
								next({ name: 'login' })
							} else {
								next()
							}
						})
					} else if (store.state.user != null) {
						next()
					} else {
						next({ name: 'login' })
					}
				},
				children: [
					{
						path: '',
						name: 'profile',
						component: Overview_view,
						meta: langMeta.profile
					},
					{
						path: langRoutes.bookings,
						name: 'bookings',
						component: ProfileBookings_view,
						meta: langMeta.bookings
					},
					{
						path: langRoutes.accountSettings,
						name: 'edit',
						component: ProfileEdit_view,
						meta: langMeta.accountSettings
					},
					{
						path: langRoutes.companions,
						name: 'guests',
						component: Guest_view,
						meta: langMeta.companions
					},
					{
						path: langRoutes.companions + '/:id',
						name: 'guests-edit',
						component: Guest_view,
						meta: langMeta.editCompanions
					},
					{
						path: langRoutes.bookings + '/:id',
						name: 'booking',
						component: ProfileBookings_view
					}
				]
			}
		]
	}
]

export default routes
